import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sigecom-checkbox',
  template: `
    <label class="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        [checked]="checked"
        (change)="toggle()"
        class="
          appearance-none
          w-4 h-4
          rounded
          border-2 border-sigecom-dark-gray
          box-border
          bg-transparent
          checked:border-cbde-dark-blue
          checked:bg-cbde-dark-blue
          checked:shadow-[inset_0_0_0_2px_rgb(255,255,255)]
        "
      />
      <span>{{ label }}</span>
    </label>
  `,
})
export class CheckboxComponent {
  @Input() label = '';
  @Input() checked = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  toggle() {
    this.checkedChange.emit(!this.checked);
  }
}
